module.exports = __webpack_public_path__ + "static/media/search.9af0e979.svg";